/** Figma 12683:949024 e 17019:877912. */
export const TOTAL_ATUAL_LABEL = (tipo: string) => `Total atual do ${tipo}`;
export const ESCOPO_TRANSFERIDO_LABEL = "Escopo macro transferido";
export const NOVO_TOTAL_LABEL = (tipo: string) => `Novo total do ${tipo}`;
export const SEM_PROJECAO = "sem projeção";
export const SEM_TOTAL = "—";
export const CARREGANDO_LABEL = "Calculando a revisão da projeção…";
export const COTACAO_DESTINO_TEXTO = (obra: string, moeda: string, valor: string) =>
  `Cotação da Obra ${obra}: ${moeda} = ${valor}`;
export const SEM_COTACAO_ALERTA = (obra: string, moeda: string, escopo: string) =>
  `A Obra ${obra} não tem cotação de ${moeda} para o escopo ${escopo}. Defina a cotação na Obra de destino antes de transferir.`;
